export const navigationDash = [
    {nome: 'DashBoard', icon: 'pi pi-fw pi-sliders-h', routerLink: ['dashboard']},
    {nome: 'Dash Atendimento', icon: 'pi pi-fw pi-sliders-h', routerLink: ['dashAtendimento']},
    {nome: 'Dash Ticket', icon: 'pi pi-fw pi-sliders-h', routerLink: ['dashticket']},
    {nome: 'Dash Operacional', icon: 'pi pi-fw pi-sliders-h', routerLink: ['painelControl']},
    {nome: 'Dash Operacional Ticket', icon: 'pi pi-fw pi-sliders-h', routerLink: ['painelControlTicket']},
];
